import { EntrataDiMagazzino } from "./entrataDiMagazzino.model";
import { Oda } from "./oda.model";

export class MandatoDiPagamento {
  id?: number;
  entrataDiMagazzino?: EntrataDiMagazzino;
  oda?: Oda;
  valore?: number;

  inizioPeriodoRiferimento?: Date; 
  finePeriodoRiferimento?: Date; 
  creato: Date;
  modificato: Date;
  eliminato: Date;
}